let theme: any = {};
theme.colors = {
  background_primary: "#BCBEBF",
  background_secondary: "#565959",

  primary: "#BCBEBF",
  primary_dark: "#434e5d",
  primary_light: "#F2F2F2",
  primary_green: "#22C55E",
  secondary: "#A51000",
  secondary_dark: "#871717",
  secondary_light: "#F03825",

  complementary: "#3A61A6",
  complementary_dark_01: "#084298",
  piano: "#fef7f7",
  black: "#333333",
  white: "#fcfcfc",
  gray: "#BCBCBC",
  gray_light_01: "#DDD",
  gray_light_transparency_01: "rgba(120, 120, 120, 0.3)",

  gray_dark_01: "#AAA",
  gray_dark_transparency_01: "rgba(50, 50, 50, 0.3)",

  green: "#28a745",
  green_dark: "#006400",
  green_light: "#90EE90",
  green1: "#4CAF50",
  green5: "#3E7B00",
  blue: "#6bccde",
  blue_dark: "#084298",
  blue_light: "#AEE3ED",
  blue1: "#328EA0",
  blue2: "#1A7D90",
  pink: "#ffb6c1",
  pink_light: "#ffcbdb",
  pink_dark: "#ff5f77",
  orange: "#ff7d3d",
  orange_dark: "#FD6656",
  orange_light: "#ffa024",
  brown: "#d19757",
  brown_dark: "#856404",
  brown_light: "#ffdba6",
  yellow: "#fde910",
  yellow_dark: "#ffd700",
  yellow_light: "#ffff00",
};

theme.button = {
  background_color: theme.colors.primary,
  border_radius: "5px",
  transition_duration: " 0.4s",
  focus: {
    color: theme.colors.white,
    outline: "1px solid #454545",
    background_color: theme.colors.complementary_dark_01,
  },
  hover: {
    color: theme.colors.white,
    background_color: theme.colors.primary_dark,
  },
};

theme.box_shadow = {
  box_shadow: `1px 1px 4px ${theme.colors.gray_light_transparency_01}`,
  transition_duration: " 0.4s",
  hover: {
    box_shadow: `1px 1px 8px ${theme.colors.gray_dark_transparency_01}`,
  },
};

theme.spinner = {
  radius: "85px",
  color: theme.colors.primary,
  background_color: theme.colors.secondary,
};

theme.alert_error = {
  color: theme.colors.black,
  border: "1px solid " + theme.colors.pink_dark,
  background_color: theme.colors.pink,
};
theme.alert_warning = {
  color: theme.colors.black,
  border: "1px solid " + theme.colors.yellow_dark,
  background_color: theme.colors.yellow,
};
theme.alert_info = {
  color: theme.colors.black,
  border: "1px solid " + theme.colors.blue_dark,
  background_color: theme.colors.blue_light,
};
theme.alert_success = {
  color: theme.colors.black,
  border: "1px solid " + theme.colors.green_dark,
  background_color: theme.colors.green_light,
};

theme.spacing = {
  spacing_01: "0.125rem", // 2px
  spacing_02: "0.25rem", // 4px
  spacing_03: "0.5rem", // 8px
  spacing_04: "0.75rem", // 12px
  spacing_05: "1rem", // 16px
  spacing_06: "1.5rem", // 24px
  spacing_07: "2rem", // 32px
  spacing_08: "2.5rem", // 40px
  spacing_09: "3rem", // 48px
  spacing_10: "4rem", // 64px
  spacing_11: "5rem", // 80px
  spacing_12: "6rem", // 96px
  spacing_13: "10rem", // 160px
};

export default theme;
